import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

import { ChannelConfigService } from './channel-config.service';
import { UtmPreservationService } from './utm-preservation.service';

@Injectable({ providedIn: 'root' })
export class OnlyIndicationService {
  private channelConfigService = inject(ChannelConfigService);
  private router = inject(Router);
  private utmPreservationService = inject(UtmPreservationService);

  private activeSubject = new BehaviorSubject<boolean>(false);

  /** Observable for reactive consumers (layout template). */
  isOnlyIndicationActive$: Observable<boolean> =
    this.activeSubject.asObservable();

  /** Synchronous snapshot for guards and imperative checks. */
  get isOnlyIndicationActive(): boolean {
    return this.activeSubject.value;
  }

  constructor() {
    this.channelConfigService.menus$
      .pipe(
        map((menus) => menus?.['onlyIndication'] === true),
        distinctUntilChanged()
      )
      .subscribe((isActive) => {
        this.activeSubject.next(isActive);

        if (isActive) {
          const currentPath = this.router.url.split('?')[0];
          if (currentPath !== '/indica') {
            console.warn(
              '[OnlyIndicationService] onlyIndication mode activated — redirecting to /indica'
            );
            this.redirectToIndication();
          }
        }
      });
  }

  /** Programmatic redirect to `/indica` preserving all `utm_*` params. */
  redirectToIndication(): void {
    const queryParams =
      this.utmPreservationService.addPreservedUtmToQueryParams({});
    this.router.navigate(['/indica'], { queryParams });
  }
}
